import { observer } from 'mobx-react';

import { CartItem } from '../CartItem/CartItem';
import { CartItemState } from '../CartItem/CartItemState';
import { CartItemGroup } from '../CartItemGroup/CartItemGroup';
import { CartItemGroupState } from '../CartItemGroup/CartItemGroupState';
import css from './CartItemList.css';

interface CartItemListProps {
  items: Array<CartItemState | CartItemGroupState>;
}

export const CartItemList = observer(({ items }: CartItemListProps) => {
  if (items.empty()) {
    return null;
  }

  return (
    <ul>
      {items.map((state) => {
        return (
          <li key={state.item.id} className={css.cartItemContainer}>
            {state instanceof CartItemState && <CartItem state={state} />}
            {state instanceof CartItemGroupState && <CartItemGroup state={state} />}
          </li>
        );
      })}
    </ul>
  );
});
